import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import routing from 'Utilities/routing';

import { routes } from '../../../../routes';

export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const route = routing.getMatch(location, routes) || {};

    if (!route.manageOwnScroll) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};
